import { APP_LOCAL_DATE_FORMAT } from "@/config/constants";
import { IEdoUnit } from "@/shared/model/edo-unit.model";
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Bookmark, Eye, Pencil, Trash2 } from "lucide-react";
import "moment/locale/it";
import { TextFormat } from "react-jhipster";

export interface UnitRowProps {
  unit?: IEdoUnit;
  viewUnit: (unit: IEdoUnit) => void;
  editUnit: ((unit: IEdoUnit) => void) | null;
  deleteUnit: ((unit: IEdoUnit) => void) | null;
  nested: boolean;
}

export const UnitRow = (props: UnitRowProps) => {
  const { unit, viewUnit, editUnit, deleteUnit, nested } = props;
  if (!unit) return null;

  return (
    <ListItem
      className={`flex items-center gap-3 py-2.5 transition-colors hover:bg-primary/5 ${nested ? "pl-8 sm:pl-10 pr-4" : "px-5"}`}
    >
      <ListItemIcon className="shrink-0">
        <Avatar className="h-8 w-8 bg-primary/10">
          <Bookmark className="h-3.5 w-3.5 text-primary" />
        </Avatar>
      </ListItemIcon>
      <ListItemText
        primary={
          <span className="text-sm font-medium text-[var(--color-mockup-text)]">
            {unit.title}
          </span>
        }
        secondary={
          <span className="text-xs text-[var(--color-mockup-text-light)]">
            <TextFormat
              value={unit.createdAt}
              type="date"
              format={APP_LOCAL_DATE_FORMAT}
            />
          </span>
        }
        className="min-w-0 flex-1"
      />
      <ListItemSecondaryAction className="ml-2 flex shrink-0 items-center gap-0.5">
        <IconButton
          onClick={() => viewUnit(unit)}
          aria-label="Visualizza unità"
          className="w-7 h-7 rounded-full text-[var(--color-mockup-text-light)] hover:text-primary hover:bg-primary/10"
        >
          <Eye className="h-3.5 w-3.5" />
        </IconButton>
        {editUnit != null && (
          <IconButton
            onClick={() => editUnit(unit)}
            aria-label="Modifica unità"
            className="w-7 h-7 rounded-full text-[var(--color-mockup-text-light)] hover:text-primary hover:bg-primary/10"
          >
            <Pencil className="h-3.5 w-3.5" />
          </IconButton>
        )}
        {deleteUnit != null && (
          <IconButton
            onClick={() => deleteUnit(unit)}
            aria-label="Elimina unità"
            className="w-7 h-7 rounded-full text-[var(--color-mockup-coral)] hover:bg-[var(--color-mockup-coral)]/10"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};
